import React, { useState, useEffect } from 'react';
import './DiscussionThreads.css';
import { FaRegBookmark, FaBookmark } from 'react-icons/fa';

const avatar = '/dashboard/studprof.png';

// 👇 Add static threads here
const SAMPLE_THREADS = [
  {
    id: 'static1',
    name: 'Ravi Kumar',
    title: 'Need help with recursion',
    created: 'July 1, 2025',
    tags: ['Java'],
    comments: 1,
    saved: false,
    image: avatar
  },
  {
    id: 'static2',
    name: 'Divya Reddy',
    title: 'Project feedback required',
    created: 'June 30, 2025',
    tags: ['Project'],
    comments: 2,
    saved: true,
    image: avatar
  },
  {
    id: 'static3',
    name: 'Arjun Mehta',
    title: 'Quiz 3 clarification',
    created: 'June 28, 2025',
    tags: ['Feedback'],
    comments: 0,
    saved: false,
    image: avatar
  }
];

export default function DiscussionThreads() {
  const [selectedThread, setSelectedThread] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('All');
  const [threads, setThreads] = useState([]);
  const [repliesMap, setRepliesMap] = useState({});
  const [repliedThreadIds, setRepliedThreadIds] = useState([]);

  useEffect(() => {
    fetch("https://kodez.robokalam.in/api/get-discussions.php")
      .then(res => res.json())
      .then(data => {
        if (!Array.isArray(data)) return;

        const fetched = data
          .map(d => ({
            id: d.id,
            name: d.author || "Student",
            title: d.title,
            createdRaw: new Date(d.created_at), // keep raw date for sorting
            created: new Date(d.created_at).toDateString(),
            tags: [d.tag],
            comments: 0,
            saved: false,
            image: avatar
          }))
          .sort((a, b) => b.createdRaw - a.createdRaw);

        // Load replies for each discussion
        data.forEach(discussion => {
          fetch(`https://kodez.robokalam.in/api/get-replies.php?id=${discussion.id}`)
            .then(res => res.json())
            .then(replyData => {
              if (replyData.status === "success") {
                setRepliesMap(prev => ({ ...prev, [discussion.id]: replyData.data }));
              }
            })
            .catch((e) => {
              console.warn("Reply fetch failed", e);
            });
        });

        setThreads([...fetched, ...SAMPLE_THREADS]);
      });
  }, []);

  const filtered = threads.filter(t => {
    const nameMatch = t.name.toLowerCase().includes(searchTerm.toLowerCase());
    const tagMatch = filter === "All" || t.tags.includes(filter);
    return nameMatch && tagMatch;
  });

  const toggleSave = id => {
    const updated = threads.map(t => t.id === id ? { ...t, saved: !t.saved } : t);
    setThreads(updated);
  };

  const handleReply = async (id) => {
    if (!replyText.trim()) return;

    const res = await fetch("https://kodez.robokalam.in/api/save-reply.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        discussion_id: id,
        author: "Mentor",
        message: replyText
      }),
    });

    const data = await res.json();
    if (data.status === "success") {
      alert("✅ Reply posted! Students will now see this.");
      setReplyText("");
      setSelectedThread(null);
      setRepliedThreadIds(prev => [...prev, id]);

      // Refresh replies immediately
      fetch(`https://kodez.robokalam.in/api/get-replies.php?id=${id}`)
        .then(res => res.json())
        .then(replyData => {
          if (replyData.status === "success") {
            setRepliesMap(prev => ({ ...prev, [id]: replyData.data }));
          }
        });
    } else {
      alert("Reply failed");
    }
  };

  return (
    <div className="discussion-wrapper">
      <div className="discussion-header">
        <h2>Discussion Threads</h2>
        <div className="discussion-actions">
          <input
            type="text"
            placeholder="Search by student name"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
          <select value={filter} onChange={e => setFilter(e.target.value)}>
            <option value="All">All</option>
            <option value="Doubt">Doubt</option>
            <option value="Java">Java</option>
            <option value="Feedback">Feedback</option>
            <option value="Project">Project</option>
          </select>
        </div>
      </div>

      <div className="discussion-list">
        {filtered.map(thread => (
          <div className="discussion-card" key={thread.id}>
            <div className="discussion-left">
              <img src={thread.image} alt={thread.name} className="student-avatar" />
            </div>
            <div className="discussion-right">
              <h3>{thread.title}</h3>
              <div className="meta-row">
                <span className="author">{thread.name}</span>
                <span className="created">Created {thread.created}</span>
              </div>
              <div className="tags-row">
                {thread.tags.map(tag => (
                  <span key={tag} className="tag">{tag}</span>
                ))}
              </div>
              <div className="icons-row">
                <span>💬 {thread.comments}</span>
                <button
                  onClick={() => toggleSave(thread.id)}
                  className={`bookmark ${thread.saved ? 'saved' : ''}`}
                  title="Save"
                >
                  {thread.saved ? <FaBookmark className="filled" /> : <FaRegBookmark />}
                </button>
              </div>
              {repliedThreadIds.includes(thread.id) ? (
                <button className="reply-btn replied" disabled>
                  Replied
                </button>
              ) : (
                <button onClick={() => setSelectedThread(thread.id)} className="reply-btn">
                  Reply
                </button>
              )}

              {selectedThread === thread.id && (
                <div className="reply-box">
                  <textarea
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    placeholder="Type your reply here..."
                  />
                  <button onClick={() => handleReply(thread.id)}>Send</button>
                </div>
              )}

              {repliesMap[thread.id] && repliesMap[thread.id].length > 0 && (
                <div className="replies-section">
                  <h4>Mentor Replies:</h4>
                  {repliesMap[thread.id].map(r => (
                    <div key={r.id} className="reply">
                      <strong>{r.author}</strong>: {r.message}
                      <div className="reply-time">{new Date(r.created_at).toLocaleString()}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p className="empty">No threads found</p>}
      </div>
    </div>
  );
}
